"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function removeAttendeeCamera(attendeeId) {
  return (0, _utils.actionCreator)(_types.BROADCAST_REMOVE_ATTENDEE_CAMERA, attendeeId);
}
var _default = exports["default"] = removeAttendeeCamera;